import React from 'react';
import styles from './Button.module.scss';

interface Props extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: () => void;
  level?: string;
  disabled?: boolean;
}

const Button: React.FC<Props> = ({ children, onClick, level = 'high', disabled, ...rest }) => {
  return (
    <button
      {...rest}
      data-testid="button"
      type="button"
      className={`${styles.Button} ${styles[level]}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
